import 'slick-carousel/slick/slick';
import $ from "jquery";

class Blog {
    constructor() {
        
        console.log('Blog');

        $('.posts').slick({
            mobileFirst: true,
            dots: true,
            infinite: true,
            autoplay:true,
            autoplaySpeed:3500,
            speed: 600,
            slidesToShow: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: 'unslick',
                }
            ]
        });

        $('.slider-cta').slick({
            dots: false,
            infinite: true,
            autoplay:false,
            autoplaySpeed:3500,
            speed: 600,
            slidesToShow: 3,
            prevArrow: `<img loading="lazy" class="prev" src="${base_url}/wp-content/themes/basedigital/assets/img/arrow-prev.svg" alt="Arrow image">`,
            nextArrow: `<img loading="lazy" class="next" src="${base_url}/wp-content/themes/basedigital/assets/img/arrow-next.svg" alt="Arrow image">`,
            responsive: [{
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    adaptiveHeight: true
                }
            }]
        });
    }
}

export default Blog;